import React from 'react';
import { toast } from 'react-toastify';

import Checkbox from '@material-ui/core/Checkbox';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import { isArray, isNull } from 'lodash';

import { t, number } from '~/helpers';
import api from '~/services/api';

// import {
//   RECEBIMENTO_READ_ONLY,
//   RECEBIMENTO_SELECT_TANKS,
//   RECEBIMENTO_WAIT_FINISH,
// } from '../Form/constantes';

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

export default function TableBatch({
  listaDeTanques,
  calculodensidadeproduto,
  onAtualizaTanques,
  constrolsAt20,
  isFinalizado,
}) {
  const classes = useStyles();

  // Calcula a volume 20 compartimento
  const handleGetDensidadeA20Graus = React.useCallback(
    async (
      codigotanquefisico,
      densidade,
      temperatura,
      calculodensidadeproduto
    ) => {
      if (densidade > 0 && temperatura > 0 && calculodensidadeproduto > 0) {
        try {
          const { data } = await api.get(
            `/calculodensidades/converteDensidadePara20Graus/${densidade}/${temperatura}/${calculodensidadeproduto}`
          );

          const { msgErroDensidadeAmbiente, msgErroTemperaturaAmbiente } = data;

          if (
            String(msgErroDensidadeAmbiente).length > 0 &&
            String(msgErroTemperaturaAmbiente).length > 0
          ) {
            const err = [
              `Batelada ${codigotanquefisico} densidade 20 - ${msgErroDensidadeAmbiente}`,
              `Batelada ${codigotanquefisico} temperatura - ${msgErroTemperaturaAmbiente}`,
            ];
            if (isArray(err)) err.map((e) => toast.error(t(e)));
          } else {
            if (String(msgErroTemperaturaAmbiente).length > 0) {
              const err = [
                `Batelada ${codigotanquefisico} temperatura - ${msgErroTemperaturaAmbiente}`,
              ];
              if (isArray(err)) err.map((e) => toast.error(t(e)));
            }
            if (String(msgErroDensidadeAmbiente).length > 0) {
              const err = [
                `Batelada ${codigotanquefisico} densidade 20 - ${msgErroDensidadeAmbiente}`,
              ];
              if (isArray(err)) err.map((e) => toast.error(t(e)));
            }
          }

          return data.densidade20;
        } catch (err) {
          if (isArray(err)) err.map((e) => toast.error(t(e)));
          else toast.error(t(err));
        } finally {
        }
      } else {
      }
    },
    []
  );

  const handleChangeDensidadeBatelada = React.useCallback(
    async (
      event,
      codigotanquefisico,
      idtanquefisico,
      listaDeTanquesAux,
      calculodensidadeproduto
    ) => {
      // const strValue = String(event.target.value);

      const valorDigitado = Number(event.target.value);
      for (let idx = 0; idx < listaDeTanquesAux.length; idx++) {
        if (listaDeTanquesAux[idx].idtanquefisico === idtanquefisico) {
          listaDeTanquesAux[
            idx
          ].densidadeambientefimdescarganftanque = valorDigitado;
          if (
            listaDeTanquesAux[idx].temperaturabateladafimdescarganftanque > 0 &&
            listaDeTanquesAux[idx].densidadeambientefimdescarganftanque > 0
          ) {
            // if (strValue.length > 4) {
            const valor20 = await handleGetDensidadeA20Graus(
              codigotanquefisico,
              listaDeTanquesAux[idx].densidadeambientefimdescarganftanque,
              listaDeTanquesAux[idx].temperaturabateladafimdescarganftanque,
              calculodensidadeproduto
            );
            listaDeTanquesAux[
              idx
            ].densidadebateladafimdescarganftanque = valor20;
            // } else {
            // listaDeTanquesAux[idx].densidadebateladafimdescarganftanque = 0;
            // }
          } else {
            listaDeTanquesAux[idx].densidadebateladafimdescarganftanque = 0;
          }
          onAtualizaTanques(listaDeTanquesAux);
        }
      }
    },
    [listaDeTanques, handleGetDensidadeA20Graus, onAtualizaTanques]
  );

  const handleChangeTemperaturaBatelada = React.useCallback(
    async (
      event,
      codigotanquefisico,
      idtanquefisico,
      listaDeTanquesAux,
      calculodensidadeproduto
    ) => {
      const strValue = String(event.target.value);

      const valorDigitado = Number(event.target.value);
      for (let idx = 0; idx < listaDeTanquesAux.length; idx++) {
        if (listaDeTanquesAux[idx].idtanquefisico === idtanquefisico) {
          listaDeTanquesAux[
            idx
          ].temperaturabateladafimdescarganftanque = valorDigitado;
          if (
            listaDeTanquesAux[idx].temperaturabateladafimdescarganftanque > 0 &&
            listaDeTanquesAux[idx].densidadeambientefimdescarganftanque > 0
          ) {
            // if (strValue.length > 1) {
            const valor20 = await handleGetDensidadeA20Graus(
              codigotanquefisico,
              listaDeTanquesAux[idx].densidadeambientefimdescarganftanque,
              listaDeTanquesAux[idx].temperaturabateladafimdescarganftanque,
              calculodensidadeproduto
            );
            listaDeTanquesAux[
              idx
            ].densidadebateladafimdescarganftanque = valor20;
            // } else {
            //  listaDeTanquesAux[idx].densidadebateladafimdescarganftanque = 0;
            // }
          } else {
            listaDeTanquesAux[idx].densidadebateladafimdescarganftanque = 0;
          }
          onAtualizaTanques(listaDeTanquesAux);
        }
      }
    },
    [listaDeTanques, handleGetDensidadeA20Graus, onAtualizaTanques]
  );

  const handleSelectTanque = React.useCallback(
    async (idtanquefisico, tanques) => {
      for (let idx = 0; idx < tanques.length; idx++) {
        if (tanques[idx].idtanquefisico === idtanquefisico) {
          if (!isNull(tanques[idx].idbateladafim)) {
            tanques[idx].idbateladafim = null;
          } else {
            tanques[idx].idbateladafim = tanques[idx].idbateladaini;
            tanques[idx].temperaturabateladafimdescarganftanque =
              tanques[idx].temperaturabateladainidescarganftanque;
            tanques[idx].densidadebateladafimdescarganftanque =
              tanques[idx].densidadebateladainidescarganftanque;
            tanques[idx].densidadeambientefimdescarganftanque =
              tanques[idx].densidadeambienteinidescarganftanque;
            document.getElementById(`tanque_densidade${idtanquefisico}`).value =
              tanques[idx].densidadeambienteinidescarganftanque;
            document.getElementById(
              `tanque_temperatura${idtanquefisico}`
            ).value = tanques[idx].temperaturabateladainidescarganftanque;
          }
          onAtualizaTanques(tanques);
        }
      }
    },
    [listaDeTanques, onAtualizaTanques]
  );

  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell>{t('s.operacao.batelada.codigotanquefisico')}</TableCell>
            <TableCell>Nova Batelada</TableCell>
            <TableCell align="right">
              {t('s.operacao.batelada.densidadeobs')}
            </TableCell>
            <TableCell align="right">
              {t('s.operacao.batelada.temperaturaobs')}
            </TableCell>
            <TableCell align="right">
              {t('s.operacao.batelada.densidade20')}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {listaDeTanques.map((tanque) => (
            <TableRow key={tanque.codigotanquefisico}>
              <TableCell component="th" scope="row">
                {tanque.codigotanquefisico}
              </TableCell>

              <TableCell component="th" scope="row">
                <Checkbox
                  disabled={isFinalizado}
                  id={`check_${tanque.idtanquefisico}`}
                  checked={isNull(tanque.idbateladafim)}
                  onChange={() =>
                    handleSelectTanque(tanque.idtanquefisico, listaDeTanques)
                  }
                />
              </TableCell>

              <TableCell align="right">
                <TextField
                  disabled={isFinalizado || !isNull(tanque.idbateladafim)}
                  InputProps={
                    isNull(tanque.idbateladafim) && {
                      inputProps: {
                        style: { textAlign: 'right', color: 'black' },
                      },
                    }
                  }
                  type="number"
                  id={`tanque_densidade${tanque.idtanquefisico}`}
                  error={tanque.densidadeambientefimdescarganftanque === 0}
                  defaultValue={tanque.densidadeambientefimdescarganftanque}
                  // value={tanque.densidadeambientefimdescarganftanque}
                  onChange={(event) => {
                    handleChangeDensidadeBatelada(
                      event,
                      tanque.codigotanquefisico,
                      tanque.idtanquefisico,
                      listaDeTanques,
                      calculodensidadeproduto
                    );
                  }}
                  onKeyDown={(event) => {
                    const charCode = event.which ? event.which : event.keyCode;
                    if (charCode === 8 || (charCode >= 46 && charCode <= 57)) {
                      // console.log(event.target.value);
                      // return true;
                    } else {
                      if (
                        charCode === 109 ||
                        charCode === 107 ||
                        charCode === 189 ||
                        charCode === 16
                      ) {
                        event.preventDefault();
                        event.target.value = '0';
                        return false;
                      }
                      // if (Number(event.target.value) > 99) {
                      //   event.preventDefault();
                      //   event.target.value = '0';
                      //   return false;
                      // }
                    }
                  }}
                  onKeyUp={(event) => {
                    const charCode = event.which ? event.which : event.keyCode;
                    if (charCode === 8 || (charCode >= 46 && charCode <= 57)) {
                      // console.log(event.target.value);
                      // return true;
                    } else {
                      // if (Number(event.target.value) > 99) {
                      //   event.preventDefault();
                      //   event.target.value = '0';
                      //   return false;
                      // }
                    }

                    if (event.key === 'Enter') {
                      // console.log(event.target.value);
                      // handleAtualizaTemperaturaCompartimentos(event, compartimento.iddescarganfcompartimento, listaDeCompartimentos);
                    }
                  }}
                  onBlur={(event) => {
                    // handleAtualizaVolumeDeclaradoCompartimentos(event, compartimento.iddescarganfcompartimento, listaDeCompartimentos);
                  }}
                />
              </TableCell>

              <TableCell align="right">
                <TextField
                  disabled={isFinalizado || !isNull(tanque.idbateladafim)}
                  InputProps={
                    isNull(tanque.idbateladafim) && {
                      inputProps: {
                        max: 100,
                        min: 0,
                        pattern: '[0-9]*',
                        style: { textAlign: 'right', color: 'black' },
                      },
                    }
                  }
                  type="number"
                  id={`tanque_temperatura${tanque.idtanquefisico}`}
                  error={tanque.temperaturabateladafimdescarganftanque === 0}
                  defaultValue={tanque.temperaturabateladafimdescarganftanque}
                  // value={tanque.temperaturabateladafimdescarganftanque}
                  onChange={(event) => {
                    // handleChange
                    handleChangeTemperaturaBatelada(
                      event,
                      tanque.codigotanquefisico,
                      tanque.idtanquefisico,
                      listaDeTanques,
                      calculodensidadeproduto
                    );
                  }}
                  onKeyDown={(event) => {
                    const charCode = event.which ? event.which : event.keyCode;
                    if (charCode === 8 || (charCode >= 46 && charCode <= 57)) {
                      // console.log(event.target.value);
                      // return true;
                    } else {
                      if (
                        charCode === 109 ||
                        charCode === 107 ||
                        charCode === 189 ||
                        charCode === 16
                      ) {
                        event.preventDefault();
                        event.target.value = '0';
                        return false;
                      }
                      // if (Number(event.target.value) > 99) {
                      //   event.preventDefault();
                      //   event.target.value = '0';
                      //   return false;
                      // }
                    }
                  }}
                  onKeyUp={(event) => {
                    const charCode = event.which ? event.which : event.keyCode;
                    if (charCode === 8 || (charCode >= 46 && charCode <= 57)) {
                      // console.log(event.target.value);
                      // return true;
                    } else {
                      // if (Number(event.target.value) > 99) {
                      //   event.preventDefault();
                      //   event.target.value = '0';
                      //   return false;
                      // }
                    }

                    if (event.key === 'Enter') {
                      // console.log(event.target.value);
                      // handleAtualizaTemperaturaCompartimentos(event, compartimento.iddescarganfcompartimento, listaDeCompartimentos);
                    }
                  }}
                  onBlur={(event) => {
                    // handleAtualizaTemperaturaCompartimentos(event, compartimento.iddescarganfcompartimento, listaDeCompartimentos);
                  }}
                />
              </TableCell>

              <TableCell align="right">
                {number(tanque.densidadebateladafimdescarganftanque, 4)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
